import {gql} from 'apollo-angular';


export interface ReferenceDataEditRules {
  add: boolean;
  addWithRestriction: boolean;
  edit: boolean;
  delete: boolean;
  copy: boolean;
}

export const referenceDataEditRules = gql`
  fragment referenceDataEditRules on ReferenceDataEditRules {
    add
    addWithRestriction
    edit
    delete
    copy
  }
`;
